import { FeaturedProductsType } from './FeaturedProducts';

const productsCountForAlternatingSizesLayout = 4;
const productsCountForVerticalTitleLayout = 3;

export const getProductsCountForLayout = (layoutType: FeaturedProductsType): number => (layoutType === FeaturedProductsType.alternatingSizes
    ? productsCountForAlternatingSizesLayout
    : productsCountForVerticalTitleLayout);
